<template>
  <div class="container mt-5">
    <h2>Sign up</h2>
    <form @submit.prevent="signup">
      <div class="mb-3 col-md-6">
        <label for="userId" class="form-label">Name</label>
        <input type="text" v-model="name" class="form-control" id="userId" required />
      </div>
      <div class="mb-3 col-md-6">
        <label for="userId" class="form-label">Email</label>
        <input type="text" v-model="email" class="form-control" id="userId" required />
      </div>
      <div class="mb-3 col-md-6">
        <label for="password" class="form-label">Password</label>
        <input type="password" v-model="password" class="form-control" id="password" required />
      </div>
      <button type="submit" class="btn btn-dark">Sign up</button>
      <p v-if="errorMessage" class="text-danger">{{ errorMessage }}</p>
    </form>
    <p class="mt-3">Already have an account? <router-link to="/login">Go To Login</router-link></p>
  </div>
</template>

<script>
import axios from 'axios';
import { BASE_URL } from '@/globals'
import { usePageMeta } from '@/composables/usePageMeta';

export default {
  name: 'SignupComponent',
  data() {
    return {
      name: '',
      email: '',
      password: '',
      errorMessage: '',
    };
  },
  mounted() {
    usePageMeta({
      title: "Signup | Nilkhet Books",
      description: "Place for quality books and stationery items",
      image: "",
    });
  },
  methods: {
    async signup() {
      try {
        const body = { 
          name: this.name,
          email: this.email,
          password: this.password 
        }
        await axios.post(`${BASE_URL}/api/auth/register`, body);
        this.$router.push('/login');
      } catch (error) {
        this.errorMessage = error.response.data.message;
      }
    },
  },
};
</script>
